// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsForm-moduleformBody__MEhRX";
export { _1 as "formBody" }
